import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// import App from "./App";
// import AppParking from "./AppParking";
import AppIsolated from "./AppIsolated";
import reportWebVitals from "./reportWebVitals";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <nav className="bg-gray-800 border-gray-600 shadow shadow">
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-1.5 sm:p-3">
        <a
          href="https://diegovargasg.github.io/coolmaps/"
          className="flex items-center"
        >
          <FontAwesomeIcon
            icon={faGlobe}
            width="24"
            style={{ fontSize: 24 }}
            className="text-white"
          />
          <span className="self-center text-lg sm:text-xl text-white ml-2 font-semibold whitespace-nowrap dark:text-white">
            Cool Maps
          </span>
        </a>
      </div>
    </nav>
    <AppIsolated />
    <footer className="fixed bottom-0 left-0 z-20 w-full py-2 px-2 sm:p-4 md:items-center md:justify-between bg-gray-800 border-gray-600 shadow">
      <div className="flex w-full">
        <div className="w-2/3">
          <span className="text-sm sm:text-center text-gray-400 text-xs sm:text-sm">
            &copy; 2024 - Diego Vargas
            <a
              href="https://www.linkedin.com/in/diego-vargas-dev/"
              target="_blank"
              rel="noreferrer"
              className="ml-2 w-12"
            >
              <FontAwesomeIcon
                icon={faLinkedin}
                width="18"
                style={{ fontSize: 18 }}
                className="inline"
              />
            </a>
            <a
              href="https://github.com/diegovargasg"
              target="_blank"
              rel="noreferrer"
              className="ml-2 text-xs sm:text-sm"
            >
              <FontAwesomeIcon
                icon={faGithub}
                width="18"
                style={{ fontSize: 18 }}
                className="inline"
              />
            </a>
          </span>
        </div>
        <div className="w-1/3 text-end">
          <a
            href="https://diegovargasg.github.io/coolmaps/"
            className="hover:underline font-medium text-gray-400 sm:mt-0 text-xs sm:text-sm"
          >
            More cool maps
          </a>
        </div>
      </div>
    </footer>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
